// method to check non-empty and non-null

import { ACRS, CLAIMS_LOCALES, CLAIMS_REGISTRATION, CLAIMS_USER_PROFILE, CLIENT_ID, DISPLAY, ESIGNET_UI_BASE_URL, GRANT_TYPE, MAX_AGE, PROMPT, REDIRECT_URI, REDIRECT_URI_REGISTRATION, REDIRECT_URI_USER_PROFILE, SCOPE_REGISTRATION, SCOPE_USER_PROFILE } from "./cred";

// values, if present then give default value
const checkEmptyNullValue = (initialValue, defaultValue) =>
  initialValue && initialValue !== "" ? initialValue : defaultValue;

const generateRandomString = (strLength = 16) => {
  let result = '';
  const characters = 'abcdefghijklmnopqrstuvwxyz0123456789';

  for (let i = 0; i < strLength; i++) {
    const randomInd = Math.floor(Math.random() * characters.length);
    result += characters.charAt(randomInd);
  }
  return result;
}

const state = "eree2311";
const nonce = generateRandomString();
const responseType = "code";
const scopeUserProfile = checkEmptyNullValue(
  SCOPE_USER_PROFILE,
  "openid profile"
);
const scopeRegistration = checkEmptyNullValue(
  SCOPE_REGISTRATION,
  "openid profile"
);
const display = checkEmptyNullValue(DISPLAY, "page");
const prompt = checkEmptyNullValue(PROMPT, "consent");
const grantType = checkEmptyNullValue(
  GRANT_TYPE,
  "authorization_code"
);
const maxAge = MAX_AGE;
const claimsLocales = checkEmptyNullValue(CLAIMS_LOCALES, "en");
const authorizeEndpoint = "/authorize";
const clientId = CLIENT_ID;
const uibaseUrl = ESIGNET_UI_BASE_URL;
const redirect_uri_userprofile = checkEmptyNullValue(
  REDIRECT_URI_USER_PROFILE,
  REDIRECT_URI
);
const redirect_uri_registration = checkEmptyNullValue(
  REDIRECT_URI_REGISTRATION,
  REDIRECT_URI
);
const acr_values = ACRS;
const userProfileClaims = checkEmptyNullValue(
 CLAIMS_USER_PROFILE,
  "{}"
);
const registrationClaims = checkEmptyNullValue(
  CLAIMS_REGISTRATION,
  "{}"
);

const claims = {
  userinfo: {
    given_name: {
      essential: true,
    },
    phone_number: {
      essential: false,
    },
    email: {
      essential: true,
    },
    picture: {
      essential: false,
    },
    gender: {
      essential: false,
    },
    birthdate: {
      essential: false,
    },
    address: {
      essential: false,
    },
  },
  id_token: {},
};

const clientDetails = {
  nonce: nonce,
  state: state,
  clientId: clientId,
  scopeUserProfile: scopeUserProfile,
  scopeRegistration: scopeRegistration,
  response_type: responseType,
  redirect_uri_userprofile: redirect_uri_userprofile,
  redirect_uri_registration: redirect_uri_registration,
  display: display,
  prompt: prompt,
  acr_values: acr_values,
  claims_locales: claimsLocales,
  max_age: maxAge,
  grant_type: grantType,
  uibaseUrl: uibaseUrl,
  authorizeEndpoint: authorizeEndpoint,
  userProfileClaims: userProfileClaims ?? encodeURI(JSON.stringify(claims)),
  registrationClaims: registrationClaims ?? encodeURI(JSON.stringify(claims)),
};

export default clientDetails;
